
import MComponent from '../Toolkit/Components/Component';
import React, {ReactElement} from 'react';
import styles from './Turnaround.module.css';
import {DrawingBySummary} from '../Api/ControllerTypes/DrawingTypes';
import DrawnBySummaryControl from './DrawnBySummaryControl';

type Props = {
    SummaryList: DrawingBySummary[];
    Totals: DrawingBySummary;
    TurnaroundTime: number;
};

type State = {};

class TurnaroundControl extends MComponent<Props, State> {
    public render(): ReactElement {
        return <React.Fragment>
            <div>
                <DrawnBySummaryControl SummaryList={this.props.SummaryList}
                                           Totals={this.props.Totals}/>
            </div>
            <div className={styles.control}>
                <table className={styles.table}>
                    <tbody>
                        <tr className={styles.row}>
                            <td className={styles.totals}>Average Turnaround Time (days):</td>
                            <td className={styles.totals}>{this.props.TurnaroundTime}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </React.Fragment>;
    }
}

export default TurnaroundControl;